import { AUTH_USER_POOL_WEB_CLIENT_ID } from '@cfra-nextgen-frontend/shared/src/config';

export const getAwsAmplifyLocalStorageKey = ({ username, key }: { username: string; key: string }) => {
    return `CognitoIdentityServiceProvider.${AUTH_USER_POOL_WEB_CLIENT_ID}.${username}.${key}`;
};
